import { useParams } from "react-router-dom"
import { IconCalendarRepeat } from "@tabler/icons-react"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { canManageAppointments } from "@/lib/appointments-access"
import { useAppSelector } from "@/store"
import "@/app/booking-calendar/bookingCalendar.css"
import { ManualRescheduleUnavailable, ManualRescheduleWorkspace } from "./components/ManualRescheduleWorkspace"

/**
 * Appointments → Availability → Manual reschedule (AB#811, SU10): `/appointments/availability/resolve/:overrideId`.
 * Reached from the resolution choice ("Manual reschedule") and the override detail's "Resolve affected
 * bookings"; no nav entry. appointments:manage only, which every endpoint it calls takes; "not
 * available" with the week view off (AmsAvailabilityWeekView), as the server's 404 says too.
 */
export default function ManualReschedulePage() {
  const { overrideId } = useParams()
  const permissions = useAppSelector((state) => state.permissions.permissions)
  const canManage = canManageAppointments(permissions)
  // Absent in a store without the slice; only a read that came back with the flag off says "off".
  const features = useAppSelector((state) => state.features)
  const flagOff = !!features?.loaded && !features.features.amsAvailabilityWeekView

  return (
    <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6 px-4 lg:px-6">
      <div className="flex items-center gap-2">
        <IconCalendarRepeat className="size-6" />
        <h1 className="text-2xl font-bold">Manual reschedule</h1>
      </div>

      {!canManage ? (
        <Alert data-testid="manual-reschedule-not-allowed">
          <AlertTitle>Not allowed</AlertTitle>
          <AlertDescription>Rescheduling an override&apos;s appointments needs appointments:manage.</AlertDescription>
        </Alert>
      ) : flagOff || !overrideId ? (
        <ManualRescheduleUnavailable />
      ) : (
        <ManualRescheduleWorkspace key={overrideId} overrideId={overrideId} />
      )}
    </div>
  )
}
